import React from 'react'
import {PanelWrapper} from "./PanelWrapper";
import {Card} from "../Card";
import {isSelected, loadingSkeleton} from '../EntitySelectorModal.helpers'
import {EmptyState} from "../EmptyState";
import useGetCollections from "../../../hooks/api/useGetCollections";
import {Collection} from "../../../types/Collection";
import {type SelectedItemsData} from "../../EntitySelector/EntitySelector.types";
import {ENTITY_TYPES} from "../../EntitySelector/EntitySelector.constants";

// Types ----

type CollectionsPanelProps = {
  onSelect: (collection: Collection) => void
  selectedItems: SelectedItemsData
  siteId?: number | null
  isMaxSelected?: boolean
}

// Component ----

function CollectionsPanel({ onSelect, selectedItems, siteId, isMaxSelected }: CollectionsPanelProps) {
  const {data: collections, isLoading} = useGetCollections({
    sites: siteId?.toString(),
    per_page: 1000,
  });

  return (
      <PanelWrapper isLoading={isLoading}>
        {isLoading ?
          loadingSkeleton :
          <>
            {!!collections?.data?.length ? collections?.data.map(collection => {
                const selected = isSelected(collection, ENTITY_TYPES.COLLECTION, selectedItems);

                return (
                  <Card
                    key={collection.id}
                    onClick={() => onSelect(collection)}
                    heading={collection.name}
                    footer={collection.location}
                    imageUrl={collection.images[0]?.preview_url}
                    active={selected}
                    disabled={isMaxSelected && !selected}
                  />
                )
              }) :
              <EmptyState />
            }
          </>
        }
      </PanelWrapper>
  );
}

export {CollectionsPanel};